import React, { Fragment } from 'react';
import { Query } from '../../../reactApolloCompat';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../component/form/Grid';
import DataHighlight from '../../../component/metrics/DataHighlight';
import Graph from '../../../component/metrics/Graph';
import MetricCard from '../../../component/metrics/MetricCard';
import { getMyClient } from '../../../apollo';
import { metricColour, metricHashColour } from '../../../component/metrics/metricConstatnts';
import PieChart from '../../../component/metrics/PieChart';
import { prettyNumber } from '../../../util/strings';
import { CONVERSION_TYPE_COLOURS } from '../Metrics';
import { ENQUIRY_TYPES } from '../../quotes/EnquiryConstants';
import MixedChart from '../../../component/metrics/MixedChart';

export default withStyles({})(props => {
    const [reloading, setReloading] = React.useState(false);
    const [prevType, setPrevType] = React.useState(null);
    const [mode, setMode] = React.useState(null);

    const { period, variant } = props;
    const { type, label } = period || null;

    if (type !== prevType) {
        // fake a reload, so CSS animations can restart
        setReloading(true);
        setPrevType(type);
    }

    const variables = {
        metricList: [
            { name: 'myEnquiries', variables: JSON.stringify({ ...period, variant }) },
            //{ name: 'myFunerals', variables: JSON.stringify({ ...period, variant }) },
            { name: 'myConversions', variables: JSON.stringify({ ...period, variant }) }
        ]
    };

    const query = gql`
        query ServicePerformance($metricList: [MetricsRequest]!) {
            loadMetrics(metrics: $metricList) {
                name
                result
            }
        }
    `;

    const heading = variant === 'team' ? "Your Team's" : variant === 'company' ? "The Company's" : 'Your';
    const titles = variant === 'team' ? 'Your team have' : variant === 'company' ? 'The company has' : "You've";

    const { colourPreneed, colourPhone, colourAtneed } = CONVERSION_TYPE_COLOURS;

    const renderResult = ({ data, loading, error }) => {
        if (loading) setReloading(true);
        else setReloading(false);

        const { loadMetrics } = (!error && data) || {};
        const enqMetric = (loadMetrics && loadMetrics.find(e => e.name === 'myEnquiries')) || null;
        const enqResultRaw = (enqMetric && JSON.parse(enqMetric.result)) || [];
        const enqResult = (enqResultRaw && enqResultRaw.Results) || [];
        const enqCount = (enqResult.length && enqResult.map(e => Number(e.Count)).reduce((a, b) => a + b)) || 0;
        /*
        const funMetric = (loadMetrics && loadMetrics.find(e => e.name === 'myFunerals')) || null;
        const funResultRaw = (funMetric && JSON.parse(funMetric.result)) || 0;
        const funResult = (funResultRaw && funResultRaw.Results) || [];
        const funCount = funResult.Count || 0;
        */
        const conMetric = (loadMetrics && loadMetrics.find(e => e.name === 'myConversions')) || null;
        const conResultRaw = (conMetric && JSON.parse(conMetric.result)) || [];
        const conResult = (conResultRaw && conResultRaw.Results) || [];
        const conCount = (conResult.length && conResult.map(e => Number(e.Count)).reduce((a, b) => a + b)) || 0;

        const enqGoal = (
            ((enqResultRaw && enqResultRaw.Goals && enqResultRaw.Goals.Total) || 0) /
            (type === 'quarter' ? 4 : type === 'month' ? 12 : 1)
        ).toFixed(0);
        const funGoal = (
            ((conResultRaw && conResultRaw.Goals && conResultRaw.Goals.Conversions) || 0) /
            (type === 'quarter' ? 4 : type === 'month' ? 12 : 1)
        ).toFixed(0);

        const enqRate = Math.min(1, enqCount / enqGoal);
        const conRate = Math.min(1, conCount / funGoal);
        // const funRate = Math.min(1, funCount / funGoal);

        const enqColour = metricColour(enqRate);
        const conColour = metricColour(conRate);
        // const funColour = metricColour(funRate);

        const enqPhoneType = enqResult.length && enqResult.filter(e => e.EnquiryType === 'PHONE');
        const enqAtneedType = enqResult.length && enqResult.filter(e => e.EnquiryType === 'ATNEED');
        const enqPreneedType = enqResult.length && enqResult.filter(e => e.EnquiryType === 'PRENEED');
        const enqPhoneCount = (enqPhoneType && enqPhoneType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;
        const enqAtneedCount = (enqAtneedType && enqAtneedType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;
        const enqPreneedCount = (enqPreneedType && enqPreneedType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;
        /*
        const enqPhoneRate = (enqPhoneCount / enqCount) * 100 || 0;
        const enqAtneedRate = (enqAtneedCount / enqCount) * 100 || 0;
        const enqPreneedRate = (enqPreneedCount / enqCount) * 100 || 0;
        */

        const conPhoneType = conResult.length && conResult.filter(e => e.EnquiryType === 'PHONE');
        const conAtneedType = conResult.length && conResult.filter(e => e.EnquiryType === 'ATNEED');
        const conPreneedType = conResult.length && conResult.filter(e => e.EnquiryType === 'PRENEED');
        const conPhoneCount = (conPhoneType && conPhoneType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;
        const conAtneedCount = (conAtneedType && conAtneedType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;
        const conPreneedCount = (conPreneedType && conPreneedType.reduce((sum, obj) => sum + obj.Count, 0)) || 0;

        const myMode = mode || 'All';
        const niceMode = (ENQUIRY_TYPES.find(obj => obj.value === myMode) || { label: 'All' }).label;
        const groupedData = resultArray =>
            resultArray.reduce((acc, { EnquiryType, EnquiryMethod, Count }) => {
                if (myMode === 'All' || EnquiryType === myMode) {
                    acc[EnquiryMethod] = (acc[EnquiryMethod] || 0) + Count;
                }
                return acc;
            }, {});

        const conGroup = groupedData(conResult);
        const enqGroup = groupedData(enqResult);
        const conRates = Object.keys(enqGroup).map(method => {
            const conversions = conGroup[method] || 0;
            const total = enqGroup[method] || 0;
            const rate = total > 0 ? (conversions / total) * 100 : null;
            return null === rate ? null : Number(rate.toFixed(2));
        });

        const mixedChartData = {
            labels: enqResult.reduce((acc, item) => {
                const enqMethod = item.EnquiryMethod;
                if (!acc.includes(enqMethod)) acc.push(enqMethod);
                return acc;
            }, []),
            showLine: false,
            datasets: [
                {
                    type: 'line',
                    label: '% Conversion Rate',
                    data: conRates,
                    spanGaps: true,
                    borderColor: '#9999BBAA',
                    backgroundColor: conRates.map(val => metricHashColour(val)),
                    pointRadius: 6,
                    pointHoverRadius: 12,
                    yAxisID: 'yPercentage'
                },
                {
                    type: 'bar',
                    label: 'Converted',
                    data: Object.values(conGroup),
                    backgroundColor: conRates.map(val => metricHashColour(val)),
                    pointStyle: 'rect',
                    yAxisID: 'yNumbers'
                },
                {
                    type: 'bar',
                    label: 'Total',
                    backgroundColor: '#35327c',
                    data: Object.values(enqGroup),
                    pointStyle: 'rect',
                    yAxisID: 'yNumbers'
                }
            ]
        };
        const mixedChartOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                yPercentage: {
                    beginAtZero: true,
                    position: 'left',
                    ticks: {
                        callback: function(value) {
                            return value + '%';
                        }
                    },
                    grid: { drawOnChartArea: false } // no lines required
                },
                yNumbers: {
                    beginAtZero: true,
                    position: 'right',
                    ticks: { precision: 0 } // Forces the axis to only use whole numbers
                }
            },
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true
                    }
                },
                tooltip: {
                    callbacks: {
                        title: function(context) {
                            return `${niceMode} Enquiries by ${context[0].label}`;
                        }
                    }
                }
            }
        };
        return (
            <Fragment>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                    <div className="highlight-container">
                        <MetricCard variant={enqColour}>
                            <DataHighlight
                                topText={`${titles} taken`}
                                data={
                                    <Fragment>
                                        {prettyNumber(enqPhoneCount)} quotation
                                        <br />
                                        {prettyNumber(enqPreneedCount)} pre-need
                                        <br />
                                        {prettyNumber(enqAtneedCount)} at-need
                                    </Fragment>
                                }
                                bottomText={`enquiries for ${label}`}
                                variant={enqColour}
                            />
                        </MetricCard>
                        <MetricCard variant={conColour}>
                            <DataHighlight
                                topText={`${titles} converted`}
                                data={
                                    <Fragment>
                                        {prettyNumber(conPhoneCount)} quotation
                                        <br />
                                        {prettyNumber(conPreneedCount)} pre-need
                                        <br />
                                        {prettyNumber(conAtneedCount)} at-need
                                    </Fragment>
                                }
                                bottomText={`enquiries for ${label}`}
                                variant={conColour}
                            />
                        </MetricCard>
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} lg={6} sx={{ order: { xs: 0, sm: 1, md: 1, lg: 0 } }}>
                    <MetricCard>
                        <Graph
                            variant="one"
                            modes={ENQUIRY_TYPES}
                            value={mode}
                            onModeChange={(evt, value) => setMode(value)}
                            placeholder={'All Enquiries'}
                            title={<span>Enquiry Method & Conversion</span>}
                        >
                            <MixedChart
                                loading={reloading}
                                variant
                                colour
                                label
                                total
                                data={mixedChartData}
                                options={mixedChartOptions}
                            />
                        </Graph>
                    </MetricCard>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                    <MetricCard>
                        <Graph variant="three" title="Enquiries Taken By Type:">
                            <PieChart
                                loading={reloading}
                                data={[
                                    { label: 'Quotation', value: enqPhoneCount, colour: colourPhone },
                                    { label: 'Pre-need', value: enqPreneedCount, colour: colourPreneed },
                                    { label: 'At-need', value: enqAtneedCount, colour: colourAtneed }
                                ]}
                            />
                        </Graph>
                    </MetricCard>
                </Grid>
            </Fragment>
        );
    };

    return (
        <Grid container spacing={3}>
            <Grid item pc>
                <h2>{heading} Performance</h2>
            </Grid>
            <Query query={query} variables={variables} client={getMyClient()} fetchPolicy="cache-and-network">
                {result => renderResult(result)}
            </Query>
        </Grid>
    );
});
